// extracted by mini-css-extract-plugin
module.exports = {"NavArrow":"style_NavArrow__2edRu"};